'use client';

export {
  requestOtp,
  verifyOtp,
  loginWithProvider,
  logout,
  updateProfile,
  addAddress,
  makeDefaultAddress,
  subscribeNewsletter,
} from './api/customer-queries';
